const path = '/img/products/sound-matrix-v10';

export const BANNER_DATA = {
  title: 'SoundMatrix V10，4K超高清摄像机',
  slogan: '更高清、更纯净、更智能、更便捷打造极致会议体验',
  backgroundImg: `${path}/banner.webp`,
  backgroundImgMobile: `${path}/banner-mobile.webp`,
  buttonText: '立即购买',
  linkText: '申请试用',
  type: 'v10',
  businessLink: 'https://item.jd.com/10067368441294.html',
  experienceLink: '/form/consult/experience-sound-matrix-v10',
};

export const FEATURES = {
  title: '更高清、更纯净、更智能、更便捷，打造极致会议体验！',
  items: [
    {
      title: '4K超高清画质',
      picUrl: `${path}/icon1.webp`,
    },
    {
      title: '12倍光学变焦',
      picUrl: `${path}/icon2.webp`,
    },
    {
      title: '低照度超高信噪比',
      picUrl: `${path}/icon3.webp`,
    },
    {
      title: '智能语音跟踪技术',
      picUrl: `${path}/icon4.webp`,
    },
    {
      title: '一键调用预置位',
      picUrl: `${path}/icon5.webp`,
    },
    {
      title: ' USB即插即用',
      picUrl: `${path}/icon6.webp`,
    },
  ],
};

export const SECTION1 = {
  title1: '更高清！4K高清画质,12倍光学变焦,',
  title2: '清晰捕捉每一处会议细节！',
  desc: '采用全新一代SONY 1/2.5英寸、 最大842万像素的高品质UHDCMOS传感器，可实现4K(3840x2160) 超高分辨率的优质图像。光学变焦达到12倍，并支持16倍数字变焦，放大图像不失真，放大会议每一处细节',
  videoUrl: `${path}/video1.mp4`,
  placeholderImg: `${path}/placeholder1.webp`,
};

export const SECTION2 = {
  title1: '更纯净！低照度超高信噪比,',
  title2: '还原干净清晰的真实场景！',
  desc: '全新CMOS图像传感器可有效降低在低照度情况下的图像噪声，使画面内容更纯净清晰。同时应用2D和3D降噪算法，大幅降低了图像噪声，即便是超低照度情况下，依然保持画面干净清晰，图像信噪比高达55dB以上',
  picUrl: `${path}/section2.webp`,
};

export const SECTION3 = {
  title1: '更智能！智能语音跟踪技术,',
  title2: '精准捕捉每一个关键时刻！',
  desc: '采用智能语音跟踪技术和自动框选技术，当参会者在摄像头画面之外说话时，能及时调整摄像头角度，让线上参会人不止闻其声，还能确保见其人',
  videoUrl: `${path}/video2.mp4`,
  placeholderImg: `${path}/placeholder3.webp`,
};

export const SECTION4 = {
  title1: '更智能！自动框选技术，自动调节画面',
  title2: '构造最佳视图！',
  desc: '采用自动框选技术，当会议中有多个参会者加入或者离开画面时，摄像头会自动调节画面大小以获得最佳构图。',
  picUrl: `${path}/section4.webp`,
};

export const SECTION5 = {
  title1: '更便捷！即插即用,一键调用预置位,',
  title2: '方便快速开启、控制会议进程!',
  desc: 'USB接口即插即用，无需安装驱动。一键调用预置位，通过遥控器操作，可以一键调用10个预置位，最多可设置255个预置位，快速切换到重要位置',
  videoUrl: `${path}/video3.mp4`,
  placeholderImg: `${path}/placeholder4.webp`,
};

export const SECTION6 = {
  title: '最佳拍档，快速搭建会议室',
  desc: 'SoundMatrixA10 智能会议麦克风音箱为您的高质量会议保驾护航',
  picUrl: `${path}/section5.webp`,
  picUrlMobile: `${path}/section5-mobile.webp`,
};

export const TIP = {
  hint: '若想咨询详情，可立即联系我们：',
  highlight: 'SoundMatrix@streamlake.com',
};
